// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Design Tokens (łatwe przenoszenie z mockupów AI) ===== */
:root {
    /* Typography - rozmiary odpowiadające Tailwind */
    --section-text-xs: 0.75rem;      /* 12px - dla ID kontraktu */
    --section-text-10: 0.625rem;     /* 10px - dla badge statusu */
    --section-text-sm: 0.875rem;     /* 14px - dla aliasu i metadanych */
    --section-text-base: 1rem;       /* 16px - domyślny */
    --section-text-lg: 1.125rem;     /* 18px - dla tytułu h6 */
    --section-text-xl: 1.5rem;       /* 24px - dla głównych nagłówków */

    /* Spacing */
    --section-padding-compact: 0.5rem 0.75rem;  /* py-2 px-3 */
    --section-padding-comfortable: 1rem;        /* p-4 dla kontraktów */
    --section-gap-sm: 0.5rem;        /* 8px */
    --section-gap-md: 0.75rem;       /* 12px */
    --section-gap-lg: 1rem;          /* 16px */

    /* Colors */
    --section-bg-default: aliceblue;
    --section-bg-hover: #e3f2fd;
    --section-bg-active: #e3f2fd;

    --section-text-primary: #212529;
    --section-text-secondary: #6c757d;
    --section-text-success: rgb(50, 130, 50);
    --section-text-muted: #6c757d;
}

/* ===== Section Action Menu ===== */
.section-action-menu {
    margin-left: 10px;
}

/* ===== Accordion Override (scopowane) ===== */
.section-accordion .accordion-button {
    padding: 0;
    background: transparent !important;
    box-shadow: none !important;
    border: none;
}

/* Ukrycie domyślnej strzałki Bootstrapa, bo mamy własną */
.section-accordion .accordion-button::after {
    display: none !important;
    content: none !important;
}

.section-accordion .accordion-button:focus {
    box-shadow: none !important;
}

.section-accordion .accordion-button:not(.collapsed) {
    background: transparent !important;
}

.section-accordion .accordion-item {
    border: 0;
    background: transparent;
}

.section-accordion .accordion-body {
    padding: 0.5rem 0;
}

/* ===== Accordion Border for Nested Items ===== */
/* Add border to items that are NOT cards (nested sections) */
.section-accordion:not(.section-card) {
    border-bottom: 1px solid #dee2e6; /* Subtle separator */
}
.section-accordion:not(.section-card):last-child {
    border-bottom: none;
}

.section-card {
    background-color: white;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    /* Border left color is injected via inline style */
    border-left-width: 4px;
    border-left-style: solid;
    overflow: hidden; /* Ensures child border-radius doesn't break card shape */
}

/* Ensure accordion button inside card is clean */
.section-card .accordion-button {
    padding: 0 !important;
}

/* ===== Section Header Styles ===== */
/* ===== State Colors (Tailwind Palette Match) ===== */
.state-active {
    background-color: #f2faff !important; /* blue-50 */
    color: var(--section-text-primary);
}

.state-hover:hover {
    background-color: #f9fafb; /* gray-50 */
}

/* Base override to ensure hover doesn't conflict with transparent backgrounds */
.section-header {
    /* Base styles mainly for layout */
    cursor: pointer;
    transition: background-color 0.2s ease;
    background-color: #f6f6f6;
}

/* Domyślny styl (np. dla nagłówków podrzędnych) */
.section-header-default {
    background-color: var(--section-bg-default);
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem; /* px-2 py-1 */
}

.section-header-default:hover {
    background-color: var(--section-bg-hover);
}

.section-header-active {
    background-color: var(--section-bg-active);
}

/* Typography classes - łatwe przenoszenie z mockupów */
.text-xs {
    font-size: var(--section-text-xs);
}

.text-10 {
    font-size: var(--section-text-10);
}

.text-sm {
    font-size: var(--section-text-sm);
}

.text-lg {
    font-size: var(--section-text-lg);
}

.text-xl {
    font-size: var(--section-text-xl);
}


/* ===== Contract Header Specific - MOVED TO TasksGlobal.css ===== */

/* ===== Scroll-target highlight animation ===== */
@keyframes section-highlight-pulse {
    0%   { box-shadow: 0 0 0 0   rgba(50, 130, 50, 0.0); }
    20%  { box-shadow: 0 0 0 6px rgba(50, 130, 50, 0.55); }
    50%  { box-shadow: 0 0 0 2px rgba(50, 130, 50, 0.15); }
    70%  { box-shadow: 0 0 0 6px rgba(50, 130, 50, 0.45); }
    100% { box-shadow: 0 0 0 0   rgba(50, 130, 50, 0.0); }
}

.section-scroll-highlight {
    animation: section-highlight-pulse 1.8s ease-out forwards;
    border-radius: 0.25rem;
    position: relative;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/View/Resultsets/FilterableTable/FilterableTable.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;IACI,iDAAiD;IACjD,0BAA0B,OAAO,4BAA4B;IAC7D,2BAA2B,MAAM,6BAA6B;IAC9D,2BAA2B,MAAM,mCAAmC;IACpE,yBAAyB,QAAQ,oBAAoB;IACrD,2BAA2B,MAAM,yBAAyB;IAC1D,yBAAyB,QAAQ,kCAAkC;;IAEnE,YAAY;IACZ,yCAAyC,GAAG,cAAc;IAC1D,mCAAmC,SAAS,uBAAuB;IACnE,wBAAwB,SAAS,QAAQ;IACzC,yBAAyB,QAAQ,SAAS;IAC1C,sBAAsB,WAAW,SAAS;;IAE1C,WAAW;IACX,+BAA+B;IAC/B,2BAA2B;IAC3B,4BAA4B;;IAE5B,+BAA+B;IAC/B,iCAAiC;IACjC,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA,oCAAoC;AACpC;IACI,iBAAiB;AACrB;;AAEA,+CAA+C;AAC/C;IACI,UAAU;IACV,kCAAkC;IAClC,2BAA2B;IAC3B,YAAY;AAChB;;AAEA,0DAA0D;AAC1D;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD,6DAA6D;AAC7D;IACI,gCAAgC,EAAE,qBAAqB;AAC3D;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,wCAAwC;IACxC,mDAAmD;IACnD,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB,EAAE,yDAAyD;AAC/E;;AAEA,iDAAiD;AACjD;IACI,qBAAqB;AACzB;;AAEA,sCAAsC;AACtC,sDAAsD;AACtD;IACI,oCAAoC,EAAE,YAAY;IAClD,kCAAkC;AACtC;;AAEA;IACI,yBAAyB,EAAE,YAAY;AAC3C;;AAEA,gFAAgF;AAChF;IACI,kCAAkC;IAClC,eAAe;IACf,sCAAsC;IACtC,yBAAyB;AAC7B;;AAEA,kDAAkD;AAClD;IACI,2CAA2C;IAC3C,sBAAsB;IACtB,uBAAuB,EAAE,cAAc;AAC3C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,uDAAuD;AACvD;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;;AAGA,oEAAoE;;AAEpE,kDAAkD;AAClD;IACI,OAAO,4CAA4C,EAAE;IACrD,OAAO,6CAA6C,EAAE;IACtD,OAAO,6CAA6C,EAAE;IACtD,OAAO,6CAA6C,EAAE;IACtD,OAAO,4CAA4C,EAAE;AACzD;;AAEA;IACI,yDAAyD;IACzD,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd","sourcesContent":["/* ===== Design Tokens (łatwe przenoszenie z mockupów AI) ===== */\n:root {\n    /* Typography - rozmiary odpowiadające Tailwind */\n    --section-text-xs: 0.75rem;      /* 12px - dla ID kontraktu */\n    --section-text-10: 0.625rem;     /* 10px - dla badge statusu */\n    --section-text-sm: 0.875rem;     /* 14px - dla aliasu i metadanych */\n    --section-text-base: 1rem;       /* 16px - domyślny */\n    --section-text-lg: 1.125rem;     /* 18px - dla tytułu h6 */\n    --section-text-xl: 1.5rem;       /* 24px - dla głównych nagłówków */\n\n    /* Spacing */\n    --section-padding-compact: 0.5rem 0.75rem;  /* py-2 px-3 */\n    --section-padding-comfortable: 1rem;        /* p-4 dla kontraktów */\n    --section-gap-sm: 0.5rem;        /* 8px */\n    --section-gap-md: 0.75rem;       /* 12px */\n    --section-gap-lg: 1rem;          /* 16px */\n\n    /* Colors */\n    --section-bg-default: aliceblue;\n    --section-bg-hover: #e3f2fd;\n    --section-bg-active: #e3f2fd;\n\n    --section-text-primary: #212529;\n    --section-text-secondary: #6c757d;\n    --section-text-success: rgb(50, 130, 50);\n    --section-text-muted: #6c757d;\n}\n\n/* ===== Section Action Menu ===== */\n.section-action-menu {\n    margin-left: 10px;\n}\n\n/* ===== Accordion Override (scopowane) ===== */\n.section-accordion .accordion-button {\n    padding: 0;\n    background: transparent !important;\n    box-shadow: none !important;\n    border: none;\n}\n\n/* Ukrycie domyślnej strzałki Bootstrapa, bo mamy własną */\n.section-accordion .accordion-button::after {\n    display: none !important;\n    content: none !important;\n}\n\n.section-accordion .accordion-button:focus {\n    box-shadow: none !important;\n}\n\n.section-accordion .accordion-button:not(.collapsed) {\n    background: transparent !important;\n}\n\n.section-accordion .accordion-item {\n    border: 0;\n    background: transparent;\n}\n\n.section-accordion .accordion-body {\n    padding: 0.5rem 0;\n}\n\n/* ===== Accordion Border for Nested Items ===== */\n/* Add border to items that are NOT cards (nested sections) */\n.section-accordion:not(.section-card) {\n    border-bottom: 1px solid #dee2e6; /* Subtle separator */\n}\n.section-accordion:not(.section-card):last-child {\n    border-bottom: none;\n}\n\n.section-card {\n    background-color: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    /* Border left color is injected via inline style */\n    border-left-width: 4px;\n    border-left-style: solid;\n    overflow: hidden; /* Ensures child border-radius doesn't break card shape */\n}\n\n/* Ensure accordion button inside card is clean */\n.section-card .accordion-button {\n    padding: 0 !important;\n}\n\n/* ===== Section Header Styles ===== */\n/* ===== State Colors (Tailwind Palette Match) ===== */\n.state-active {\n    background-color: #f2faff !important; /* blue-50 */\n    color: var(--section-text-primary);\n}\n\n.state-hover:hover {\n    background-color: #f9fafb; /* gray-50 */\n}\n\n/* Base override to ensure hover doesn't conflict with transparent backgrounds */\n.section-header {\n    /* Base styles mainly for layout */\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    background-color: #f6f6f6;\n}\n\n/* Domyślny styl (np. dla nagłówków podrzędnych) */\n.section-header-default {\n    background-color: var(--section-bg-default);\n    border-radius: 0.25rem;\n    padding: 0.25rem 0.5rem; /* px-2 py-1 */\n}\n\n.section-header-default:hover {\n    background-color: var(--section-bg-hover);\n}\n\n.section-header-active {\n    background-color: var(--section-bg-active);\n}\n\n/* Typography classes - łatwe przenoszenie z mockupów */\n.text-xs {\n    font-size: var(--section-text-xs);\n}\n\n.text-10 {\n    font-size: var(--section-text-10);\n}\n\n.text-sm {\n    font-size: var(--section-text-sm);\n}\n\n.text-lg {\n    font-size: var(--section-text-lg);\n}\n\n.text-xl {\n    font-size: var(--section-text-xl);\n}\n\n\n/* ===== Contract Header Specific - MOVED TO TasksGlobal.css ===== */\n\n/* ===== Scroll-target highlight animation ===== */\n@keyframes section-highlight-pulse {\n    0%   { box-shadow: 0 0 0 0   rgba(50, 130, 50, 0.0); }\n    20%  { box-shadow: 0 0 0 6px rgba(50, 130, 50, 0.55); }\n    50%  { box-shadow: 0 0 0 2px rgba(50, 130, 50, 0.15); }\n    70%  { box-shadow: 0 0 0 6px rgba(50, 130, 50, 0.45); }\n    100% { box-shadow: 0 0 0 0   rgba(50, 130, 50, 0.0); }\n}\n\n.section-scroll-highlight {\n    animation: section-highlight-pulse 1.8s ease-out forwards;\n    border-radius: 0.25rem;\n    position: relative;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
